/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Line, Path, Rect } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 16,
        height: 18,
        viewBox: "0 0 16 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M1.74 2a1 1 0 0 1 1-1h5.65a1 1 0 0 1 1 1v14.3H1.74z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M14.26 5.48a1 1 0 0 0-1-1H10.4a1 1 0 0 0-1 1V16.3h4.87z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 3.13,
                y: 2.74,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 3.13,
                y: 5.87,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 3.13,
                y: 9,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 3.13,
                y: 12.13,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 5.91,
                y: 2.74,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 10.78,
                y: 6.22,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 5.91,
                y: 5.87,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 10.78,
                y: 9.35,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 5.91,
                y: 9,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 10.78,
                y: 12.13,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Rect, {
                x: 5.91,
                y: 12.13,
                width: 2.09,
                height: 2.09,
                rx: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Line, {
                x1: 1,
                y1: 16,
                x2: 14.65,
                y2: 16,
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
